<template>
  <el-autocomplete class="inline-input" v-model="obj.currency" :fetch-suggestions="currencySearch" placeholder="币种"
    @select="currencySelect" :style='styleStr' :size="sizeType">
    <template slot-scope="scope">
      <p>{{scope.item.code}}</p>
    </template>
  </el-autocomplete>
</template>

<script>
import Api from '@/components/Api/index.js'
export default {
  props:{
    obj:{
      type:Object,
      default: ()=>{return{}}
    },
    styleStr:{
      type:String,
      default:'width:0.7rem'
    },
    sizeType:{
      type:String,
      default:'mini'
    },
  },
  mounted(){
    // new ResourceApi('resource').currencyList({code:''}).then(res => {
    //   if (res.status == 200) {    
    //     this.obj.currency = res.data[0].code
    //   }
    // })
  },
  methods:{
    currencySearch(queryString, cb){
      new Api('resource').currencySearch({code:queryString}).then(res => {
        if (res.status == 200) {
          cb(res.data)
        }
      })
    },
    currencySelect(item){
      this.$set(this.obj,'currency',item.code)
      if(this.obj.rate){
        this.$set(this.obj,'rate',item.payeeRate)
      }
      this.$emit("currencySelect",item)
    },
  }
}
</script>

<style>

</style>